import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn, Routes } from "@angular/router";

import { billingRoutes } from "@billing/routes/billing.routes";
import { documentationRoutes } from "@documentation/routes/documentation.routes";
import { DocumentationRoutesConstants } from "@documentation/routes/documentation.routes.constants";
import { DocumentsStore } from "@documentation/state/documents.store";
import { adminRoutes } from "@features/admin/routes/admin.routes";
import { organizationAdminRoutes } from "@features/organization/routes/organization-admin.routes";
import { organizationUserRoutes } from "@features/organization/routes/organization-user.routes";
import { loginRoutes } from "@login/routes/login.routes";

// Public document resolver - loads public document without auth
const publicDocumentResolver: ResolveFn<void> = (route: ActivatedRouteSnapshot) => {
  const store = inject(DocumentsStore);
  const id = route.paramMap.get("id");

  if (id) {
    store.loadPublicDocument(id);
  }
};

export const routes: Routes = [
  billingRoutes,
  // Public document viewer (no auth guard)
  {
    path: `${DocumentationRoutesConstants.PUBLIC}/${DocumentationRoutesConstants.MAIN}`,
    loadComponent: () => import("@documentation/documentation.component").then((m) => m.DocumentationComponent),
    data: { isPublicView: true },
    children: [
      {
        path: `${DocumentationRoutesConstants.DOCUMENT}/:id`,
        loadComponent: () => import("@documentation/components/document.component").then((m) => m.DocumentComponent),
        resolve: {
          document: publicDocumentResolver
        },
        data: { isPublicView: true },
        title: "Public Document"
      },
      {
        path: `:folderId`,
        loadComponent: () => import("@documentation/components/document.component").then((m) => m.DocumentComponent),
        resolve: {
          folder: () => inject(DocumentsStore).resetDocument()
        },
        data: { isPublicView: true },
        title: "Public Folder"
      },
      {
        path: `:folderId/${DocumentationRoutesConstants.DOCUMENT}/:id`,
        loadComponent: () => import("@documentation/components/document.component").then((m) => m.DocumentComponent),
        resolve: {
          document: publicDocumentResolver
        },
        data: { isPublicView: true },
        title: "Public Document"
      }
    ]
  },
  ...loginRoutes,
  documentationRoutes,
  adminRoutes,
  organizationAdminRoutes,
  organizationUserRoutes,
  { path: "", redirectTo: DocumentationRoutesConstants.MAIN, pathMatch: "full" },
  {
    path: "**",
    redirectTo: DocumentationRoutesConstants.MAIN
  }
];
